module.exports = __webpack_public_path__ + "img/ico-billing-history-default.8408e411.svg";